import { WEB_UI_PATH } from 'src/config';

export const WEB_UI_ROUTE_IDS = [
  'login',
  'dashboard',
  // Status
  'status_system',
  'status_interfaces',
  'status_traffic',
  'status_poe',
  'status_lacp',
  'status_dhcp',
  'status_log',
  'status_ignition',
  'status_stp',
  'status_dhcp_client',
  'status_lldp',

  // Settings
  'settings_system',
  'settings_ignition',
  'settings_ports',
  'settings_lacp',
  'settings_vlan',
  'settings_multicast',
  'settings_interfaces',
  'settings_qos',
  'settings_mirroring',
  'settings_lldp',
  'settings_stp',
  'settings_dhcp_server',
  'settings_dhcp_relay',
  'settings_dhcp_inserter',
  'settings_ntp',
  'settings_remote_logging',
  'settings_snmp',
  'settings_nat',
  'settings_mqtt',
  'settings_poe',

  // Maintenance
  'maintenance_users',
  'maintenance_settings',
  'maintenance_webserver',
  'maintenance_fwupdate',

  // Third Party Notices
  'licenses',
] as const;

export type WebUiRouteId = (typeof WEB_UI_ROUTE_IDS)[number];

const ROUTE_SET = new Set<string>(WEB_UI_ROUTE_IDS);

export type ParsedWebUiPath = {
  switchId: string | null;
  routeId: WebUiRouteId;
};

function normalizeRouteSegment(raw: string): WebUiRouteId {
  const id = raw.replace(/\.html$/i, '');
  return (ROUTE_SET.has(id) ? id : 'dashboard') as WebUiRouteId;
}

/**
 * Expects: /{WEB_UI_PATH}/{switchId} or /{WEB_UI_PATH}/{switchId}/{route}
 */
export function parseWebUiPath(pathname: string): ParsedWebUiPath {
  const p = pathname.replace(/\/+$/, '');
  const parts = p.split('/').filter(Boolean);
  if (parts[0] !== WEB_UI_PATH || parts.length < 2) {
    return { switchId: null, routeId: 'dashboard' };
  }
  const switchId = parts[1];
  if (parts.length === 2) {
    return { switchId, routeId: 'dashboard' };
  }
  const last = parts[parts.length - 1] ?? '';
  return { switchId, routeId: normalizeRouteSegment(last) };
}

export function pathForRoute(switchId: string, id: WebUiRouteId): string {
  if (id === 'dashboard') return `/${WEB_UI_PATH}/${switchId}`;
  return `/${WEB_UI_PATH}/${switchId}/${id}`;
}
